import { JournalDatePreset, JournalFilterForm, JournalSegment } from '../../types/ledgerJournal';

export const PER_PAGE_OPTIONS = [10, 20, 50, 100];

export const DEFAULT_PER_PAGE = 20;

export const DEFAULT_PRESET: JournalDatePreset = '30d';

export const DATE_PRESETS: { value: JournalDatePreset; label: string }[] = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: 'month', label: 'This month' },
  { value: 'all', label: 'All time' },
  { value: 'custom', label: 'Custom' },
];

export const EMPTY_FILTER_FORM: JournalFilterForm = {
  userId: '',
  companyId: '',
  employeeId: '',
  event: '',
  reference: '',
  preset: DEFAULT_PRESET,
  from: null,
  to: null,
};

export const SEGMENT_TITLES: Record<JournalSegment, { title: string; subtitle: string }> = {
  B2C: { title: 'B2C Ledger', subtitle: 'Retail client journals' },
  B2B: { title: 'B2B Ledger', subtitle: 'Company & employee journals' },
};

/** URL keys — the filters live in the query string so a search is a shareable link. */
export const URL_KEYS = {
  userId: 'userId',
  companyId: 'companyId',
  employeeId: 'employeeId',
  event: 'event',
  reference: 'reference',
  preset: 'preset',
  from: 'from',
  to: 'to',
  page: 'page',
  perPage: 'perPage',
  sort: 'sort',
  book: 'book',
} as const;

export const URL_DATE_FORMAT = 'yyyy-MM-dd';

export const EXPORT_HEADERS = [
  'Journal Start',
  'Date',
  'Time',
  'Event',
  'Memo',
  'Reference',
  'User ID',
  'Company ID',
  'Employee ID',
  'Zoho Status',
  'Zoho Journal ID',
  'Account',
  'Medici Account',
  'Debit',
  'Credit',
] as const;

export const JOURNAL_START_MARKER = '●';
